import { render, staticRenderFns } from "./register-dialog.vue?vue&type=template&id=9cafc9a8&scoped=true"
import script from "./register-dialog.vue?vue&type=script&lang=js"
export * from "./register-dialog.vue?vue&type=script&lang=js"
import style0 from "./register-dialog.vue?vue&type=style&index=0&id=9cafc9a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cafc9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cafc9a8')) {
      api.createRecord('9cafc9a8', component.options)
    } else {
      api.reload('9cafc9a8', component.options)
    }
    module.hot.accept("./register-dialog.vue?vue&type=template&id=9cafc9a8&scoped=true", function () {
      api.rerender('9cafc9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/register-dialog.vue"
export default component.exports